export enum Role {
    PRIMARY_USER = 'PRIMARY_USER',
    SECONDARY_USER = 'SECONDARY_USER',
    GUEST_USER = 'GUEST_USER',
    ANONYMOUS_USER = 'ANONYMOUS_USER',
    UNKNOWN = 'UNKNOWN'
}